import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";


import Form from 'views/Accounts/Form'
import List from 'views/Accounts/List'


class Accounts extends React.Component {
  render() {
    const {match}=this.props;
    return (

          <Switch>
            <Route path={`${match.path}/add`} component={Form}/>
            <Route path={`${match.path}/:id`} component={Form}/>
            <Route component={List}/>
          </Switch>

    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(Accounts);



// WEBPACK FOOTER //
// ./src/views/Accounts/Accounts.jsx